import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {SecurityService} from './security.service';
import {GroupGuard} from './group.guard';

@Injectable()
export class MyProfileGuard extends GroupGuard {

  constructor(private secSvc: SecurityService, router: Router) {
    super(secSvc, router);
    this.validate = () => this.secSvc.showMyProfile();
  }

}
